import FInput_PinyinSafeTextCounter from '@/components/FInput_PinyinSafeTextCounter';
import FSelect2 from '@/components/FSelect2';
import FComponentsLib from '@freelog/components-lib';
import { Cascader } from 'antd';
import styles from './index.less';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import province_city from '@/assets/data/province_city.json';
import fMessage from '@/components/fMessage';
import * as AHooks from 'ahooks';
import { history, useParams } from 'umi';
import FAuthenticationModal from '@/components/FAuthenticationModal';

interface SettlementInfoFormData {
  hasBankCard: boolean;
  settlementMethod: 'bankCard';
  accountType: 'individuals';
  bankAccount: string;
  bankAccountError: string;
  bankName: string;
  bankRegion: string[] | null;
  bankRegionError: string;
}

const initVal: SettlementInfoFormData = {
  hasBankCard: false,
  settlementMethod: 'bankCard',
  accountType: 'individuals',
  bankAccount: '',
  bankAccountError: '',
  bankName: '',
  bankRegion: null,
  bankRegionError: '',
};

function SettlementInfo() {
  const params = useParams<{ id: string }>();
  const [$formData, set$FormData, get$FormData] =
    FUtil.Hook.useGetState<SettlementInfoFormData>(initVal);

  const [$show, set$show] = FUtil.Hook.useGetState<boolean>(false);

  const [$showAuthenticationModal, set$showAuthenticationModal, get$showAuthenticationModal] =
    FUtil.Hook.useGetState<boolean>(true);

  AHooks.useMount(async () => {
    const {
      ret: ret2,
      errCode: errCode2,
      msg: msg2,
      data: data2,
    }: {
      ret: number;
      errCode: number;
      msg: string;
      data: {
        accountId: string;
        bankName: string;
        cardNo: string;
        cardType: number;
        ownerUserId: number;
        provId: string;
        areaId: string;
      };
    } = await FServiceAPI.Payment.queryBindWithdrawCard({
      accountId: params.id ?? '',
    });
    if (ret2 !== 0 || errCode2 !== 0) {
      fMessage(msg2, 'error');
      return;
    }

    if (!data2) {
      return;
    }

    set$FormData({
      ...get$FormData(),
      hasBankCard: true,
    });
  });

  function onChange_bankAccount(value: string) {
    // 为空时只显示红框，不展示错误文案
    const error = value === '' ? '__empty__' : '';
    set$FormData({ ...get$FormData(), bankAccount: value, bankAccountError: error });
  }

  function onChange_bankRegion(value: string[] | null) {
    let error = '';
    if (value === null) {
      error = '请选择开户银行所在地区';
    }
    set$FormData({ ...get$FormData(), bankRegion: value, bankRegionError: error });
  }

  return (
    <>
      {$show && (
        <div className={styles.settlementInfoContainer}>
          <div className={styles.headerSection}>
            <h2 className={styles.title}>{$formData.hasBankCard ? '修改' : '设置'}结算方式</h2>
          </div>

          <div className={styles.section}>
            <div className={styles.sectionTitle}>
              {
                // 结算账号
                FI18n.i18nNext.tAuto('payout_setting_payoutmethod_title')
              }
            </div>

            <div className={styles.fieldGroup}>
              <div className={styles.fieldLabel}>
                {
                  // 结算方式
                  FI18n.i18nNext.tAuto('payout_setting_payoutmethod_input')
                }
              </div>
              <div className={styles.selectorWrapper}>
                <FSelect2
                  value={$formData.settlementMethod || undefined}
                  onChange={(value) => {
                    set$FormData({ ...get$FormData(), settlementMethod: value });
                  }}
                  className={styles.selector}
                  options={[{
                    label:
                      // 银行卡
                      FI18n.i18nNext.tAuto('payout_setting_payoutmethod_input_option_debitcard'),
                    value: 'bankCard',
                  }]}
                // placeholder={'请选择'}
                />
              </div>
              <div className={styles.hintText}>{
                // 目前仅提供银行卡的结算方式，其他方式后续开放...
                FI18n.i18nNext.tAuto('payout_setting_payoutmethod_input_info')
              }</div>
            </div>

            <div className={styles.fieldGroup}>
              <div className={styles.fieldLabel}>
                {
                  // 账户类型
                  FI18n.i18nNext.tAuto('payout_setting_payoutmethod_input_accounttype')
                }
              </div>
              <div className={styles.selectorWrapper}>
                <FSelect2
                  value={$formData.accountType || undefined}
                  onChange={(value) => {
                    set$FormData({ ...get$FormData(), accountType: value });
                  }}
                  // placeholder='请选择'
                  className={styles.selector}
                  options={[
                    {
                      label:
                        // 个人账户
                        FI18n.i18nNext.tAuto('payout_setting_payoutmethod_input_accounttype_option_individual'),
                      value: 'individuals',
                    },
                    // { label: '企业账户', value: '企业账户' },
                  ]}
                />
              </div>
            </div>

            <div className={styles.fieldGroup}>
              <div className={styles.fieldLabel}>
                {
                  // 银行账号
                  FI18n.i18nNext.tAuto('payout_setting_payoutmethod_input_bankaccount')
                }
              </div>
              <div style={{ width: '100%' }}>
                <FInput_PinyinSafeTextCounter
                  lengthLimit={-1}
                  value={$formData.bankAccount}
                  hasError={$formData.bankAccountError !== ''}
                  onChangeValue={(value) => {
                    onChange_bankAccount(value.replace(/\s/g, ''));
                  }}
                  // placeholder='请输银行账号'
                  style={{ width: '100%' }}
                  onBlur={() => {
                    onChange_bankAccount(get$FormData().bankAccount.trim());
                  }}
                />
              </div>
            </div>

            {/* 开户银行 */}
            {/* <div className={styles.fieldGroup}>
            <div className={styles.fieldLabel}>开户银行</div>
            <div className={styles.selectorWrapper}>
              <AutoComplete
                value={$formData.bankName || undefined}
                onChange={(value) => {
                  set$FormData({ ...get$FormData(), bankName: value });
                }}
                placeholder={'请选择'}
                className={styles.selector}
                // suffixIcon={<DownOutlined className={styles.dropdownIcon} />}
                options={bank_names.map((name) => ({ label: name, value: name }))}
                showSearch
                filterOption={(input, option) => {
                  return option?.label?.toLowerCase().includes(input.toLowerCase()) ?? false;
                }}
              />
            </div>
          </div> */}

            <div className={styles.fieldGroup}>
              <div className={styles.fieldLabel}>
                {
                  // 开户银行所在地区
                  FI18n.i18nNext.tAuto('payout_setting_payoutmethod_input_bankregion')
                }
              </div>
              <div className={styles.selectorWrapper}>
                <Cascader
                  value={$formData.bankRegion ?? undefined}
                  onChange={(value) => {
                    onChange_bankRegion(value as string[]);
                  }}
                  onBlur={() => {
                    onChange_bankRegion(get$FormData().bankRegion);
                  }}
                  // placeholder={'请选择'}
                  className={styles.selector}
                  options={province_city}
                  status={$formData.bankRegionError ? 'error' : undefined}
                />
              </div>
            </div>
          </div>

          <div className={styles.submitSection}>
            <FComponentsLib.FRectBtn
              disabled={
                $formData.bankRegion === null ||
                $formData.bankRegionError !== '' ||
                $formData.bankAccountError !== '' ||
                $formData.bankAccount === ''
              }
              type='primary'
              onClick={async () => {
                const { bankName, bankRegion, bankAccount } = get$FormData();
                const params2: Parameters<typeof FServiceAPI.Payment.bindWithdrawCard>[0] = {
                  accountId: params.id ?? '',
                  cardType: 1,
                  // bankName: bankName,
                  // cardName: realName,
                  cardNo: bankAccount,
                  provId: bankRegion?.[0] ?? '',
                  areaId: bankRegion?.[1] ?? '',
                };
                const {
                  ret: ret2,
                  errCode: errCode2,
                  msg: msg2,
                  data: data2,
                } = await FServiceAPI.Payment.bindWithdrawCard(params2);
                if (ret2 !== 0 || errCode2 !== 0) {
                  fMessage(msg2, 'error');
                  return;
                }

                fMessage('提交成功', 'success');
                setTimeout(() => {
                  history.push(
                    FUtil.LinkTo.settlementInfo({
                      accountID: params.id ?? '',
                    }),
                  );
                }, 1000)

              }}
            >
              {
                // 提交
                FI18n.i18nNext.tAuto('payout_setting_payoutmethod_btn_submit')
              }
            </FComponentsLib.FRectBtn>
          </div>
        </div>
      )}

      <FAuthenticationModal
        open={$showAuthenticationModal}
        onOk={() => {
          set$showAuthenticationModal(false);
          set$show(true);
        }}
      />
    </>
  );
}

export default SettlementInfo;

// function fileToImageUrl(file: File) {
//   return URL.createObjectURL(file);
// }
